export const PAGE_COUNT_FILTER_SHORT_NAME = "page_count"
export const pageCountDefault = 20

const sN = PAGE_COUNT_FILTER_SHORT_NAME
const pD = pageCountDefault

export const PAGE_COUNT_FILTER_CONFIG = {
  short_name: sN,
  default_values: pD,
  is_default: value => testPageCountDefault(value), //right before clean up
  format_to_api: value => formatPageCountForAPI(value), //strip out defaults; put into the correct api form. //IF we have the value using the short code, then let's format it
  format_from_url: value => formatPageCountFromURL(value) //
}

export const testPageCountDefault = value => {
  if (value === 20) {
    return true
  } else {
    return false
  }
}

export const formatPageCountFromURL = value => {
  let cleanValue = null
  if (value) {
    if (!isNaN(value)) {
      cleanValue = value
    }
  }
  return cleanValue
}

export const formatPageCountForAPI = value => {
  if (value) {
    return { page_count: value }
  } else {
    return {}
  }
}
